import { useDraggable } from '@dnd-kit/core';

import { DossierId } from '../../../resources/dossier/types';
import { useGetAgents, useCanDisplayAvatar } from '../../../resources/agent/hooks';
import { useChangeStepStatus } from '../../../resources/dossier/mutations';

import { DossierOverview, Props } from './DossierOverview';

export function DraggableDossierOverview(
    props: Omit<
        Props,
        'agents' | 'displayAvatar' | 'isDragging' | 'isLoading' | 'attributes' | 'listeners'
    > & {
        id: DossierId;
        doNotDrag: boolean;
    },
) {
    const { data: agents } = useGetAgents();
    const canDisplayAvatar = useCanDisplayAvatar(props.dossier.agentId);

    const { isError } = useChangeStepStatus(props.id);

    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
        id: props.id,
        data: {
            dossierId: props.id,
            currentStep: props.dossier.step,
            dossierCanChangeStepTo: props.dossier.allowedChangeStepsTo,
        },
        disabled: isError || props.doNotDrag,
    });

    return (
        <DossierOverview
            ref={setNodeRef}
            attributes={attributes}
            listeners={listeners}
            isDragging={isDragging}
            agents={agents}
            displayAvatar={canDisplayAvatar}
            {...props}
        />
    );
}
